import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsUserLoggedIn } from '../../helpers/useValidateToken.ts';

interface PrivateRouteProps {
    children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const location = useLocation();
    const { isUserLoggedIn } = useIsUserLoggedIn();

    if (!isUserLoggedIn) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute;
